import { Component, Input, OnInit } from '@angular/core';
import { CommunicationService } from '../../../services/communication.service';

@Component({
  selector: 'common-contact-us-menu',
  templateUrl: './contact-us-menu.component.html',
  styleUrls: ['./contact-us-menu.component.scss'],
})
export class ContactUsMenuComponent implements OnInit {
  @Input() brandColor!: string;
  @Input() merchantPhone?: string;
  @Input() chatAllowed?: boolean;
  @Input() merchantEmail?: string;
  @Input() noteColor?: string;
  @Input() note?: string;
  loading = true;

  constructor(private communicationService: CommunicationService) {}

  ngOnInit() {
    if (this.note) {
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    } else {
      this.loading = false;
    }
  }

  openChat() {
    this.communicationService.openChat.emit();
  }
}
